export const closest = (target, parent) => {
  if (!target) return false;

  return parent === target || closest(target.parentNode, parent);
};

export const addResizeEndListener = (element, callback) => {
  if ('ResizeObserver' in window) {
    const resizeObserver = new ResizeObserver(callback);
    resizeObserver.observe(element);

    return resizeObserver;
  }

  if (!('ResizeObserver' in window)) {
    let resizeTimeout = null;
    const resizeHandler = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(callback, 400);
    };

    window.addEventListener('resize', resizeHandler);

    return resizeHandler;
  }

  return null;
};

export const removeResizeEndListener = (element, listener) => {
  if ('ResizeObserver' in window) {
    listener?.unobserve(element);
  }

  if (!('ResizeObserver' in window)) {
    window.removeEventListener('resize', listener);
  }
};

export const getScrollTop = () =>
  window.pageYOffset ||
  document.documentElement.scrollTop ||
  document.body.scrollTop;

export const getScrollLeft = () =>
  window.pageXOffset ||
  document.documentElement.scrollLeft ||
  document.body.scrollLeft;

export const getCoords = (elem) => {
  const box = elem?.getBoundingClientRect();

  const { body, documentElement } = document;

  const scrollTop = getScrollTop();
  const scrollLeft = getScrollLeft();

  const clientTop = documentElement.clientTop || body.clientTop || 0;
  const clientLeft = documentElement.clientLeft || body.clientLeft || 0;

  const top = box.top + scrollTop - clientTop;
  const left = box.left + scrollLeft - clientLeft;

  return {
    top,
    left,
  };
};

export const scrollToElement = ({
  element,
  behavior = 'smooth',
  offset = 0,
}) => {
  const { top } = getCoords(element);

  window.scrollTo({
    top: top - offset,
    left: 0,
    behavior,
  });
};
